import { Video as LucideIcon } from 'lucide-react';
import { Card } from '../ui/Card';

interface KPICardProps {
  title: string;
  value: number | string | null | undefined;
  unit?: string;
  icon: LucideIcon;
  trend?: 'up' | 'down' | 'neutral';
  color?: string;
}

export function KPICard({ title, value, unit, icon: Icon, trend, color = 'text-blue-600' }: KPICardProps) {
  const numValue = typeof value === 'number' ? value : parseFloat(value || '0');
  const safeValue = isNaN(numValue) ? 0 : numValue;

  const formattedValue = unit === '%'
    ? safeValue.toFixed(1)
    : unit === 'h' || unit === 'min'
    ? safeValue.toFixed(0)
    : safeValue.toFixed(2);

  return (
    <Card className="p-5 hover:shadow-card-hover hover:-translate-y-0.5 group">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">{title}</p>
          <div className="flex items-baseline gap-1">
            <p className="text-3xl font-bold text-gray-900 dark:text-gray-50 tracking-tight">
              {formattedValue}
            </p>
            {unit && <span className="text-lg text-gray-400 dark:text-gray-500 font-medium">{unit}</span>}
          </div>
        </div>
        <div className={`p-3 rounded-xl bg-gray-50 dark:bg-gray-800/60 ${color} transition-all duration-200 group-hover:scale-110`}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
    </Card>
  );
}
